import api from './api'

export default class BaseService {
  static getSession () {
    return api.get('/session')
  }

  static restoreSession (redirectUri) {
    return api.post('/session', {
      redirect_uri: redirectUri
    })
  }

  static cancelAuth () {
    return api.post('/cancel-authorization')
  }

  static notifyLeaving () {
    return api.post('/leaving')
  }

  static confirmConsent (data) {
    return api.post('/confirm-consent', data)
  }

  static confirmAccount (data) {
    return api.post('/confirm-account', data)
  }
}
